export default __webpack_public_path__ + "static/media/ieee_summit_2023.a06b9bdb.jpg";